<template>
       <Tabs v-model="defaultIndex" @on-click="handleTabClick">
          <TabPane label="主机列表" name="server">
            <ServerList ref="serverList" />
          </TabPane>
          <TabPane label="批量操作" name="agent">
             <AgentList ref="agentList" />
          </TabPane>
          <TabPane label="操作日志" name="log">
             <AgentLogs ref="agentLogs" />
          </TabPane>
      </Tabs>
</template>
<script>
import ServerList from './ServerList'
import AgentList from './AgentList'
import AgentLogs from './AgentLogs'
export default {
  name: 'AgentServerMain',
  components: {
    ServerList,
    AgentList,
    AgentLogs
  },
  data () {
    return {
      data: {},
      defaultIndex: 'server'
    }
  },
  watch: {
  },
  methods: {
    handleTabClick (value) {
      if (value === 'server') {
        this.$refs.serverList.getServers()
      } else if (value === 'agent') {
        // this.$refs.SpringBoardLogs.getSpringBoradLogList()
      } else if (value === 'log') {
        this.$refs.agentLogs.getAgentLogList()
      }
    }
  },
  mounted: function () {
    // this.$refs.SpringBoardLogs.getSpringBoradLogList()
  }
}
</script>
